<script lang="ts">
import { defineComponent } from 'vue';
import Tooltip from "../../components/tooltip.vue";

export default defineComponent({
  name: "Subtitle",
  components: { Tooltip },
  props: {
    /** The subtitle text to display */
    text: {
      type: String,
      required: true
    },
    /** Optional tooltip message next to the subtitle */
    tooltipMessage: {
      type: String,
      default: ""
    },
    /** Option to hide the tooltip */
    hideTooltip: {
      type: Boolean,
      default: false
    },
    tooltipPosition: {
      type: Object,
      default: () => ({
        bottom: '100%',
        left: '60%',
        transform: 'translateX(-40%)',
      })
    }
  }
});
</script>

<template>
  <div
    class="subtitle flex items-center text-slate-500 text-sm"
    v-bind="$attrs"
  >
    <span>{{ text }}</span>
    <Tooltip
      v-if="tooltipMessage"
      :message="tooltipMessage"
      variant="question"
      size="12px"
      class="ml-1"
      :position="tooltipPosition"
    />
  </div>
</template>

<style scoped>
/* Override subtitle styles here if needed */
</style>
